// src/utils/factoringRate.js
//
// A broker's factoring charge can be a percentage of the load, a fixed dollar
// amount, or both ("3% + $15"). Both parts are added into one factoring fee.
//
// The same arithmetic runs in three places: here (the load form), the PDF
// import (functions/services/factoring.js) and the server-side check that keeps
// stored fees honest (functions/src/loads/reconcileFactoringFee.js). If they
// ever disagree, the server check rewrites what the form saved, so change all
// three together.

const num = (v) => {
  const n = parseFloat(v);
  return Number.isFinite(n) ? n : 0;
};

export const round2 = (n) => Math.round(n * 100) / 100;

/** The factoring fee for a load: percentage of the price plus the fixed amount. */
export function computeFactoringFee(amount, percentage, flatFee) {
  const price = num(amount);
  const pct = num(percentage);
  const flat = num(flatFee);
  if (price <= 0 || (pct <= 0 && flat <= 0)) return 0;
  return round2((price * Math.max(pct, 0)) / 100 + Math.max(flat, 0));
}

/** "3%", "$15" or "3% + $15" — empty when neither part is set. */
export function factoringRateLabel(percentage, flatFee) {
  const pct = num(percentage);
  const flat = num(flatFee);
  const parts = [];
  if (pct > 0) parts.push(`${pct}%`);
  if (flat > 0) parts.push(`$${Number.isInteger(flat) ? flat : flat.toFixed(2)}`);
  return parts.join(' + ');
}
